module.exports = __webpack_public_path__ + "static/media/setup-analytics-animate.6a82f2da.svg";